import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import { HeadingType } from '@components/bulk_management/user-settings/resource-sidebar/ResourceTypes';

interface ResourceHeadingProps {
  length: number;
  headingType: HeadingType;
}

export const ResourceHeading: FunctionComponent<ResourceHeadingProps> = ({ length, headingType }) => {
  let headingText = '';
  if (headingType === 'brandguide') {
    headingText = length === 1 ? bfTranslate('Brandguide') : bfTranslate('Brandguides');
  } else if (headingType === 'collection') {
    headingText = length === 1 ? bfTranslate('Collection') : bfTranslate('Collections');
  } else if (headingType === 'subcollection') {
    headingText = length === 1 ? bfTranslate('Subcollection') : bfTranslate('Subcollections');
  } else if (headingType === 'workspace') {
    headingText = length === 1 ? bfTranslate('Workspace') : bfTranslate('Workspaces');
  } else if (headingType === 'portal') {
    headingText = length === 1 ? bfTranslate('Portal') : bfTranslate('Portals');
  }

  return (
    <h4 className={classnames(
      'resource-sidebar__header',
      `resource-sidebar__header--${headingType}`,
      { ['resource-sidebar__header--nested']: headingType !== 'portal' && headingType !== 'brandguide' },
      { ['resource-sidebar__header--double-nested']: headingType === 'subcollection' },
    )}>
      {headingText}
    </h4>
  );
};